import _ from "lodash";
const { createSlice, current } = require("@reduxjs/toolkit");

function removeElementById(columns, idToRemove) {
  _.forEach(columns, (column) => {
    _.remove(column.data, (item) => item._id === idToRemove);
  });

  return columns;
}

const initialState = {
  settingKanban: {},
  dataKanbanView: {
    current_page: 1,
    object_id: "",
    record_per_page: 10,
    search_with: { meta: [], data: [] },
  },
  dataCalculate: [],
  firstRecordId: null,
  lastRecordId: null,
  isLoadingPagi: false,
  totalRecord: null,
  isLoadingData: false,
  page_records: 0,
  argument: {
    first: null,
    last: null,
  },
  currentPage: 1,
  isHasMore: true,
  isReset: false,
};

const slice = createSlice({
  name: "kanbanView",
  initialState,
  reducers: {
    getSettingKanban() {},
    getSettingKanbanSuccess(state, action) {
      state.settingKanban = action.payload;
    },
    getDataKanbanView(state) {
      state.isLoadingData = true;
    },
    getDataKanbanViewSuccess(state, action) {
      if (action.payload?.reset) {
        state.dataKanbanView = action.payload;
        state.isReset = !state.isReset;
      } else {
        state.dataKanbanView = state.dataKanbanView.columns
          ? {
              columns: _.map(
                state.dataKanbanView.columns,
                (column, idx) =>
                  (column = {
                    ...column,
                    data: _(
                      column.data.concat(action.payload.columns[idx].data)
                    )
                      .reverse()
                      .uniqBy("_id")
                      .reverse()
                      .sortBy((item) => -new Date(item.created_date).getTime())
                      .value(),
                    last_record_id:
                      action?.payload?.columns[idx]?.last_record_id ||
                      column?.last_record_id,
                  })
              ),
            }
          : action.payload;
      }

      const allEmpty = _.every(action.payload.columns, (obj) =>
        _.isEmpty(obj.data)
      );
      if (allEmpty) {
        state.isHasMore = false;
      } else {
        state.isHasMore = true;
      }

      state.firstRecordId = action.payload.first_record_id;
      state.lastRecordId = action.payload.last_record_id;
      state.isLoadingData = false;
      state.page_records = action.payload.page_records;
    },
    getDataCalculate() {},
    getDataCalculateResult(state, aciton) {
      state.dataCalculate = aciton.payload;
    },
    getDataKanbanViewById() {},
    updateColumn(state, action) {
      const { index, data } = action.payload;
      state.dataKanbanView.columns[index].data = data;
    },
    updateRecordKanbanOnDrag(state, action) {},
    updateRecordKanban() {},
    updateRecordKanbanResult(state, action) {
      const columns = [...current(state.dataKanbanView.columns)];

      action.payload.data.forEach((newValueObj) => {
        columns.forEach((column, index) => {
          column.data.forEach((dataObj, idx) => {
            if (dataObj._id === action.payload.id) {
              const newDataObj = {
                ...dataObj,
                [newValueObj.id_field]: newValueObj.value,
              };

              const newData = [...columns[index].data];
              newData[idx] = newDataObj;

              columns[index] = {
                ...columns[index],
                data: [...newData],
              };
            }
          });
        });
      });

      state.dataKanbanView.columns = columns;
    },
    updateCurrentPage(state, action) {
      state.dataKanbanView.current_page = action.payload;
    },
    deleteRecord(state, action) {},
    deleteRecordResult(state, action) {
      state.dataKanbanView.columns = removeElementById(
        state.dataKanbanView.columns,
        action.payload.id
      );
    },
    getPaginationKanban(state, acion) {
      state.isLoadingPagi = true;
    },
    getPaginationKanbanSuccess(state, action) {
      state.totalRecord = action.payload.total_record;
      state.isLoadingPagi = false;
    },
    setTotalRecord(state, action) {
      state.totalRecord = action.payload;
    },
    updateArgument(state, action) {
      state.argument = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    unmountKanbanView: () => initialState,
  },
});

export default slice.reducer;

export const {
  getSettingKanban,
  getSettingKanbanSuccess,
  getDataKanbanView,
  getDataKanbanViewSuccess,
  getDataCalculate,
  getDataCalculateResult,
  updateColumn,
  updateCurrentPage,
  updateRecordKanbanOnDrag,
  updateRecordKanban,
  updateRecordKanbanResult,
  getDataKanbanViewById,
  deleteRecord,
  deleteRecordResult,
  unmountKanbanView,
  getPaginationKanban,
  getPaginationKanbanSuccess,
  setTotalRecord,
  updateArgument,
  setCurrentPage,
} = slice.actions;
